<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="pg25lev2"></a><img alt="Pan con tomate" src="images/f0025-02.jpg"/></h2>
<p class="recipe_hdnote">This is my take on the classic tomato on bread that is ubiquitous in Spanish wine and tapas bars. This is possibly one of the simplest tapas you’ll find, but I have jazzed mine up with a herby and garlicky butter.</p>
<div class="wrap">
<p class="image"><a id="page_26"></a><img alt="a couple of small plates of food and a bunch of friends is my favorite way to relax," class="vertical" src="images/f0026-01.jpg"/></p>
</div>
<p class="yield">Serves 4</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Cooking time: 5 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Preparation time: 10 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="ingred_sublist">4 large slices sourdough bread</p>
<p class="ingred_sublist">10<sup>1</sup>/<sub>2</sub> oz heirloom tomatoes</p>
<p class="ingred_sublist">1<sup>1</sup>/<sub>2</sub> oz fresh basil, or whatever herbs you like</p>
<p class="ingred_sublist">2 cloves of garlic, peeled</p>
<p class="ingred_sublist">6 tbsp salted butter</p>
<p class="ingred_sublist">sea salt and freshly ground pepper</p>
<p class="ingred_sublist">pinch of sweet smoked paprika (optional)</p>
<p class="method_txt">Grill or toast the bread on both sides. Thinly slice the tomatoes.</p>
<p class="method_txt">In a small blender or by hand, very finely chop the basil and garlic and mix together. Melt the butter in a small saucepan and add the herbs and garlic to it. Add a pinch of salt and pepper and remove from the heat before the butter browns.</p>
<p class="method_txt">Pile the tomatoes high onto the toasted bread and drizzle with the hot garlic-herb butter. Finish with a sprinkle of sweet smoked paprika, if desired, before serving.</p>
<div class="wrap">
<p class="image"><a id="page_27"></a><img alt="image" class="vertical" src="images/f0027-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13-chapter07.vue?ccdc1c22